import "./DashboardSection.css";

export default function DashboardSection({ title, description, children }) {
  return (
    <section className="dashboard-section">
      <div className="dashboard-section__header">
        <div>
          <h2>{title}</h2>
          {description && <p>{description}</p>}
        </div>
      </div>

      {children}
    </section>
  );
}
